import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';
import Tooltip from '@/components/ui-bridge/core/Tooltip';

import copy from '@/components/common/icons/copy.svg';
import info from '@/components/common/icons/info.svg';
import { BASE_URL } from '@/config';
import { generateToken } from '@/helpers/tokenGenerator';
import { showToast } from '@/store/ducks/toasts';

const ClientLink = () => {
  const [url, setUrl] = useState('');
  const dispatch = useDispatch();
  const intl = useIntl();

  const copyToClipboard = async () => {
    await navigator.clipboard.writeText(url);
    dispatch(
      showToast({
        type: 'success',
        title: 'Sucesso!',
        text: 'Link copiado.',
        duration: 5000,
      })
    );
  };

  useEffect(() => {
    const me = JSON.parse(sessionStorage.getItem('me'));
    if (me) {
      const franchise = {
        id: me.franchiseeId,
        name: me.profile.name,
        email: me.profile.email,
        phone: me.profile.phone,
        country: me.profile.country || 'BR',
      };
      const token = generateToken(franchise);
      setUrl(`${BASE_URL}/new-client/${token}`);
    }
  }, []);

  return (
    <div className="flex items-center">
      <div className="flex flex-col">
        <Tooltip
          title={intl.formatMessage({ id: 'CLIENT_LINK.AUTO_REGISTRATION_TOOLTIP' })}
          placement="top-end"
          classes={{
            tooltip: 'bg-[#5292cd] w-full max-w-[320px] shadow-lg rounded p-2 text-white text-[11px] leading-tight',
          }}
        >
          <label
            className="font-bold uppercase text-[#393939] block mb-0 mr-[5px] cursor-help"
            style={{ fontSize: '10px', textTransform: 'uppercase', fontWeight: 'bold' }}
            htmlFor="url"
          >
            <span>{intl.formatMessage({ id: 'CLIENT_LINK.AUTO_REGISTRATION_LINK' })}</span>
            <img className="inline-block ml-[5px]" style={{ width: '11px', height: '11px' }} src={info} alt="" onClick={() => copyToClipboard()} />
          </label>
        </Tooltip>
        <div className="flex items-center mt-[2px]">
          <input
            className="w-[200px] mr-[5px] border border-[#e3e3e3] rounded-[3px] px-1.5 font-semibold text-[#919191]"
            style={{ fontSize: '10px', height: '25px', backgroundColor: '#efefef' }}
            type="text"
            name="url"
            id="url"
            disabled
            value={url}
          />
          <img
            className="cursor-pointer hover:opacity-75 transition-opacity"
            style={{ width: '15px', height: '15px' }}
            src={copy}
            alt="Copiar"
            title="Copiar link"
            onClick={() => copyToClipboard()}
          />
        </div>
      </div>
    </div>
  );
};

export default ClientLink;
